import React from 'react'

import { useParams } from 'react-router-dom'

import ConfirmModal from 'components/_base/ConfirmModal'
import { useMarkCompanyAsIsp } from 'hooks/useDataChangeRequests'

type MarkAsIspProps = {
  open: boolean
  onClose: (...args: any[]) => any
}

const MarkAsIsp = ({ open, onClose }: MarkAsIspProps) => {
  const { uuid } = useParams()
  const markAsIsp = useMarkCompanyAsIsp()

  const handleConfirm = async () => {
    await markAsIsp.mutateAsync(uuid)
    onClose()
  }

  return <ConfirmModal onClose={onClose} onConfirm={handleConfirm} open={open} title="Mark company as ISP?" />
}

export default MarkAsIsp
